import React from "react";
import { Box, Button, getColor, Typography } from "fds";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import utilsCommon from "../../shared/utils/common";
import { t } from "i18next";
interface SimpleLinkPageProps {
  imagePath: string;
  pageTitle: string;
  bodymsg?: any;
  hasButtonToHome?: boolean;
  classes?: string;
}
const SimpleLinkPage: React.FC<SimpleLinkPageProps> = ({
  imagePath,
  pageTitle,
  bodymsg,
  hasButtonToHome = false,
  classes,
}) => {
  const navigate = useNavigate();

  return (
    <Box width={"100%"} height={"100%"} classes={"error"}>
      <Box classes="error-header">
        <img
          src={utilsCommon.renderWrapsodyECOLogo()}
          alt={"logo"}
          height={46}
          className="cursor pointer"
          onClick={() => navigate(`${process.env.PUBLIC_URL}/home`)}
        />
      </Box>
      <Box alignItems="center" style={{ paddingTop: 188 }} direction="column">
        <img src={imagePath} alt={"error"} />
        <Typography
          type="h2"
          classes="mg mt-20"
          whiteSpace="break-spaces"
          textAlign="center"
        >
          {pageTitle}
        </Typography>
        {bodymsg && (
          <Typography
            type="body2_rg"
            whiteSpace="break-spaces"
            textAlign="center"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
            classes="mg mt-26"
            style={{ marginTop: 26 }}
          >
            {bodymsg}
          </Typography>
        )}
        {hasButtonToHome && (
          <Button
            label={t("common.goWrapsodyeCo")}
            btnStyle="fill"
            style={{ height: "48px" }}
            width={"360px"}
            classes="mg mt-40"
            onClick={() => navigate(`${process.env.PUBLIC_URL}/home`)}
          />
        )}
      </Box>
    </Box>
  );
};
export default SimpleLinkPage;
